import { render, staticRenderFns } from "./view-payment.vue?vue&type=template&id=3552a709&scoped=true&"
import script from "./view-payment.vue?vue&type=script&lang=js&"
export * from "./view-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552a709",
  null
  
)

export default component.exports